import { QualityLevel } from '@/api-gen/api.schemas';

// Color mapping using generated enum values
const QualityLevelColorMap = {
  [QualityLevel.Unset]: '#808080',
  [QualityLevel.Good]: '#4CAF50',
  [QualityLevel.Acceptable]: '#FFEB3B',
  [QualityLevel.Bad]: '#F44336'
} as const;

const MapColorToEnum = (color?: string): QualityLevel => {
  switch (color) {
    case '#4CAF50':
      return QualityLevel.Good;
    case '#FFEB3B':
      return QualityLevel.Acceptable;
    case '#F44336':
      return QualityLevel.Bad;
    case '#808080':
    default:
      return QualityLevel.Unset;
  }
};

const MapEnumToColor = (qualityLevel?: QualityLevel): string => {
  return QualityLevelColorMap[qualityLevel ?? QualityLevel.Unset];
};

export { MapColorToEnum, MapEnumToColor };
